module.exports = __webpack_public_path__ + "static/media/pointing_arrow.dda61582.png";